/* eslint-disable import/prefer-default-export */

export const DATA_TABLE_EL_CHANGED = 'DATA_TABLE_EL_CHANGED';
export const FILTERS_CHANGED = 'FILTERS_CHANGED';
export const PAYMENT_DISPUTE_CHANGED = 'PAYMENT_DISPUTE_CHANGED';
export const PAYMENT_DISPUTE_UPLOAD_CREATED = 'PAYMENT_DISPUTE_UPLOAD_CREATED';
